export interface NavBaseItem {
  title?: string;
  route?: string;
  img?: string;
}

export interface NavSubitem extends NavBaseItem {
  img?: string;
  value?: string;
}

export interface NavItem extends NavBaseItem {
  subItems: NavSubitem[];
}

export enum NavItemType {
  SETTINGS = 'settings',
  BRANCH = 'branch',
  ACCOUNT = 'account'
}
